import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const SeekBarTrack = styled.div`
  position: relative;
  width: 100%;
  height: 8px;
  background: rgba(0, 0, 0, 0.7);
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  transition: height 0.1s linear;
  height: 10px;

  &:hover {
  }
`;

export const Progress = styled.div`
  position: absolute;
  height: 100%;
  background: repeating-linear-gradient(45deg, #a800a8, #a800a8 10px, purple 10px, purple 20px);
  /* background: #a800a8; */
  width: 0;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5), 0 0 5px 5px rgba(255, 255, 255, 0.02);
  border-radius: 5px;
  transition: width 0.3s linear;
`;

export const SeekBarThumb = styled.div`
  position: absolute;
  top: -3px;
  width: 14px;
  height: 14px;
  background: #ffffff;
  border: 2px solid pink;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;

export const Needle = styled.div`
  position: absolute;
  width: 2px;
  height: 103px;
  background: #ffc0cb7d;
  transition: left 0.3s linear;
`;
